'use client'

import { useEffect } from 'react'

import { CustomerTypes } from 'modules/customer'
import { SeoListName } from 'shared/analytics'

import { viewProductList } from '../analytics'
import { ProductTypes } from '../types/products'

interface UseProductListViewProps {
  shouldTrigger: boolean
  user: CustomerTypes | undefined
  products: ProductTypes[]
  listName: SeoListName
}

export const useProductListView = ({
  shouldTrigger,
  user,
  products = [],
  listName
}: UseProductListViewProps) => {
  useEffect(() => {
    if (shouldTrigger) {
      viewProductList({
        user,
        products,
        listName
      })
    }
  }, [shouldTrigger, user, products, listName])
}
